import { Sk } from './shared';

const CITIES = [
  { id: 'LON', x: 61,  y: 73,  active: true  },
  { id: 'AMS', x: 77,  y: 70,  active: true  },
  { id: 'PAR', x: 69,  y: 81,  active: true  },
  { id: 'BER', x: 103, y: 69,  active: true  },
  { id: 'MUN', x: 97,  y: 84,  active: true  },
  { id: 'PRA', x: 106, y: 77,  active: false },
  { id: 'VIE', x: 112, y: 84,  active: false },
  { id: 'WAR', x: 126, y: 70,  active: false },
  { id: 'MAD', x: 50,  y: 110, active: false },
  { id: 'ROM', x: 100, y: 105, active: false },
];

const LINKS: [string, string][] = [
  ['LON', 'AMS'], ['LON', 'PAR'],
  ['AMS', 'BER'], ['PAR', 'BER'],
  ['BER', 'MUN'],
];

const VEHICLES = [
  { x: 69,  y: 72 },
  { x: 86,  y: 70 },
  { x: 86,  y: 77 },
  { x: 100, y: 77 },
  { x: 100, y: 83 },
];

const IOT = [
  { x: 55,  y: 90  },
  { x: 115, y: 95  },
  { x: 130, y: 80  },
  { x: 88,  y: 100 },
];

const LEFT_STATS = [
  { label: 'FLEET',   value: '3,482' },
  { label: 'ONLINE',  value: '97.8%' },
  { label: 'MARKETS', value: '14'    },
];

const RIGHT_STATS = [
  { label: 'NODES',   value: '2.1k'  },
  { label: 'LATENCY', value: '14ms'  },
  { label: 'UPTIME',  value: '99.9%' },
];

export function MkSimTable() {
  const cm = Object.fromEntries(CITIES.map(c => [c.id, c]));

  const StatPanel = ({ stats, right }: { stats: typeof LEFT_STATS; right?: boolean }) => (
    <div className={`tc-stats${right ? ' tc-stats--r' : ''}`}>
      {stats.map(s => (
        <div key={s.label} className="tc-stat">
          <span className="tc-stat-lbl">{s.label}</span>
          <span className="tc-stat-val">{s.value}</span>
          <Sk w="85%" h="4px" />
          <Sk w="60%" h="4px" />
        </div>
      ))}
    </div>
  );

  return (
    <div className="csmk csmk-tsconn">
      <div className="tc-body">

        <StatPanel stats={LEFT_STATS} />

        <div className="tc-map-wrap">
          <svg viewBox="0 0 200 134" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <image href="/work/europe_map.webp"
              x="0" y="0" width="200" height="134"
              preserveAspectRatio="xMidYMid slice" />

            {LINKS.map(([a, b], i) => (
              <line key={i}
                x1={cm[a].x} y1={cm[a].y}
                x2={cm[b].x} y2={cm[b].y}
                className="tc-link"
              />
            ))}

            {VEHICLES.map((v, i) => (
              <g key={i} className="tc-car" transform={`translate(${v.x},${v.y})`}>
                <rect x="-3" y="-1.8" width="6" height="3.6" rx="1" />
                <rect x="-1.8" y="-3.3" width="3.6" height="2.4" rx="0.8" />
              </g>
            ))}

            {IOT.map((p, i) => (
              <g key={i} className="tc-iot">
                <circle cx={p.x} cy={p.y} r="4"   className="tc-iot-ring2" />
                <circle cx={p.x} cy={p.y} r="7"   className="tc-iot-ring" />
                <circle cx={p.x} cy={p.y} r="1.2" />
              </g>
            ))}

            {CITIES.map(c => (
              <g key={c.id} className={`tc-node${c.active ? ' active' : ''}`}>
                {c.active && <circle cx={c.x} cy={c.y} r="5" className="tc-halo" />}
                <circle cx={c.x} cy={c.y} r={c.active ? 2.5 : 1.8} />
              </g>
            ))}
          </svg>
        </div>

        <StatPanel stats={RIGHT_STATS} right />

      </div>
    </div>
  );
}
